import React, { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

const Message = styled.small`
  position: absolute;
  bottom: -1.5em;
  color: ${p => p.theme.colors.redDark};
  font-size: 0.8em;
`;

type Props = {
  name: string;
};

export const ErrorMessage: FC<Props> = memo(({ name }) => {
  const { errors } = useFormContext();
  if (!errors[name]) return null;

  return <Message>{errors[name].message}</Message>;
});
